module.exports = __webpack_public_path__ + "static/img/tools－image－3.e428972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools－image－3.png
// module id = PNnH
// module chunks = 1